import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { shellMetrics } from '../tokens';

export const styledBackstageContent = (
  theme: Theme,
): BackstageOverrides['BackstageContent'] => ({
  root: {
    boxSizing: 'border-box',
    minWidth: 0,
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: `calc(${theme.spacing(4)} + ${
        shellMetrics.mobileSidebarHeight
      }px + env(safe-area-inset-bottom))`,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
});
